export default __webpack_public_path__ + "static/media/IndustrialVisit.35dad207.png";